import type { ResolvedAppScope } from './appScope.types';
import type { EnterpriseWorkspace } from 'v5/api/enterprise/enterprise.api';
import { resolveActiveEnterpriseWorkspace } from 'v5/features/core/enterprise/resolveActiveEnterpriseWorkspace';

/** Workspace slug segment from enterprise URLs: `/app/:org/w/:workspaceSlug/...`. */
export function workspaceSlugFromEnterprisePath(
  pathname: string
): string | undefined {
  const match = pathname.match(/\/w\/([^/]+)/);
  return match?.[1];
}

/**
 * Resolves a concrete workspace slug for link generation (nav, breadcrumbs, redirects).
 * Route-matching templates may still use `:workspaceId`; links must not.
 */
export function resolveWorkspaceSlugForLinks(
  scope: ResolvedAppScope,
  pathname: string,
  workspaces: EnterpriseWorkspace[] | undefined
): string {
  if (scope.level === 'workspace' || scope.level === 'team') {
    return scope.workspaceSlug;
  }

  const fromPath = workspaceSlugFromEnterprisePath(pathname);
  if (fromPath) {
    return fromPath;
  }

  return resolveActiveEnterpriseWorkspace(workspaces, scope)
    .activeWorkspaceSlug;
}
